import { render, staticRenderFns } from "./ComeBackToCeo.vue?vue&type=template&id=6f904210&"
import script from "./ComeBackToCeo.vue?vue&type=script&lang=js&"
export * from "./ComeBackToCeo.vue?vue&type=script&lang=js&"
import style0 from "./ComeBackToCeo.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports